const styles = (theme) => ({
    container: {
        width: '32%'
    }
});

export default styles;
